export const accountManagementStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 100px)',
    paddingTop: 4,
    paddingBottom: 4,
  },
  paper: {
    padding: 4,
    width: '100%',
  },
  form: {
    marginTop: 2,
  },
  button: {
    marginTop: 2,
  },
  divider: {
    marginTop: 4,
    marginBottom: 3,
  },
  alert: {
    marginBottom: 2,
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 2,
  },
  loadingText: {
    marginTop: 2,
  },
};
